function Unknown({imgsrc}){
return(
    <div>
        <h2>Face not matched!</h2>
        <img alt="camera" style={{maxWidth:"80%", display: "block", margin:"0 auto", padding: 0}} src={imgsrc}/>
        <p>Click "Go Back" to try again.</p>
    </div>
)
}
export default Unknown